import { render } from "./StoryBox.vue?vue&type=template&id=32bf6e51&scoped=true"
import script from "./StoryBox.vue?vue&type=script&lang=js"
export * from "./StoryBox.vue?vue&type=script&lang=js"

import "./StoryBox.vue?vue&type=style&index=0&id=32bf6e51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bf6e51"]])

export default __exports__